import { BIRequests } from '~/api/BI';

import { EventDeduplicator } from '../EventDeduplicator';
import type { AnalyticsProvider } from '../types';

export class BIProvider implements AnalyticsProvider {
  readonly name = 'bi' as const;
  readonly requiresConsent = true;

  private deduplicator = new EventDeduplicator();

  isAvailable(): boolean {
    return !import.meta.env.DEV;
  }

  initialize(): void {
    this.deduplicator.start();
  }

  destroy(): void {
    this.deduplicator.destroy();
  }

  track(eventName: string, payload: Record<string, unknown>): void {
    if (this.deduplicator.isDuplicate(eventName, payload)) {
      return;
    }

    BIRequests.sendAnalytics(eventName, payload).catch(
      (error) => error && console.error(error),
    );
  }

  trackBatch(eventName: string, payload: Record<string, unknown>[]): void {
    BIRequests.sendAnalytics(eventName, payload).catch(
      (error) => error && console.error(error),
    );
  }
}
